<div fxLayout="row">
  <abc-drop-down-box
    #configCombobox
    [dataSource]="configGUIItems"
    [placeholder]="res.get('Configuration')"
    [height]="'auto'"
    [(value)]="configId"
    [displayExpr]="'name'"
    [valueExpr]="'id'"
    [gridColumns]="[{ dataField: 'name', caption: 'Name' }]"
    (onClosed)="onDropdownClosed()"
  >
    >
  </abc-drop-down-box>
</div>
